/**
 * Created by vetal on 23.11.15.
 */


jQuery.extend(String.prototype, {

    /**
     * Java hash function
     * @returns {number}
     */
    hashCode : function(){
        var hash = 5381;
        for (i = 0; i < this.length; i++) {
            char = this.charCodeAt(i);
            hash = ((hash << 5) + hash) + char; /* hash * 33 + c */
        }
        return hash;
    },

    /**
     * Replace all occurrences of the search string with the replacement string
     *
     * @param String search
     * @param String replace
     * @return String
     */
    replaceAll: function (search, replace) {
    	return this.trim().split(search).join(replace);
    },

    /**
     * Replace all non [a-z0-9] characters to "-". So it will be able to use in URLs
     *
     * @return String
     */
    urlify: function () {
    	return this.trim().replace(/[^A-Za-z0-9]+/g, '-').toLowerCase();
    },

    /**
     * Escape to prevent XSS
     */
    escape: function () {
        var lt = /</g,
            gt = />/g,
            ap = /'/g,
            ic = /"/g;
        return this.replace(lt, "&lt;").replace(gt, "&gt;").replace(ap, "&#39;").replace(ic, "&#34;");
    },

    /**
     * Capitalize hyphen-separated words, 'string-like-this' becomes 'StringLikeThis'
     */
    capitalizeWords: function () {
        return this.split('-').map(function(str){ return str.replace(/^[a-z]/, function (char) { return char.toUpperCase(); }); }).join('');
    },

    includesCaseInsensitive: function (substring) {
        return this.toUpperCase().indexOf(substring.toUpperCase()) !== -1;
    },

    /*
        @todo split into sentences and capitalize each of them
    */
    toSentenceCase: function(){
        return this.charAt(0).toUpperCase() + this.slice(1);
    }

});

define("utils.string", function(){});

